import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useAuth0 } from "../../../contexts/AuthManager/Auth";
import { ErrorStyles } from "./ErrorComponent";

const Error403 = () => {
  const navigate = useNavigate();
  const authContext = useAuth0();

  return (
    <ErrorStyles>
      <div className="raven-error">
        <div>403: Sorry, you aren{`'`}t authorized to view this content.</div>
        <div>
          If you were recently authorized, you may need to{" "}
          <span
            onClick={() => {
              navigate("/");
              authContext?.loginWithRedirect();
            }}
            className="raven-error-retry"
          >
            sign-in again
          </span>{" "}
          for it to take effect.
        </div>
        <div>
          Still confused? Don{`'`}t hesitate to{" "}
          <Link to={"/unauthorized/help"}>reach out for assistance</Link>.
        </div>
      </div>
    </ErrorStyles>
  );
};
export default Error403;
